import styles from "../styles/LoginForm.module.scss";
import React, { useState } from "react";

export default function LoginForm({
  username,
  password,
  handleUsername,
  handlePassword,
  login,
}: {
  username: string;
  password: string;
  handleUsername: (event) => void;
  handlePassword: (event) => void;
  login: () => void;
}) {
  return (
    <div className={styles.form_container}>
      <div className={styles.text}>&nbsp;Username</div>
      <input
        className={styles.input_dialog}
        onChange={handleUsername}
        value={username}
      />
      <div className={styles.text}>&nbsp;Password</div>
      <input
        type="password"
        className={styles.input_dialog}
        onChange={handlePassword}
        value={password}
      />
      <div className={styles.smaller_yellow_text}>
        <span>&nbsp;</span>
        <a href="login">Forget Password?</a>
      </div>
      <button className={styles.yellow_button} onClick={login}>
        Log in
      </button>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <a href="login" className={styles.smaller_dark_blue_text}>
        New Harty?
      </a>
      <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span className={styles.smaller_yellow_text}>
        <a href="register">Create Account</a>
      </span>
    </div>
  );
}
